export default __webpack_public_path__ + "static/media/finishicon.f07de9f2.svg";